import { createFileRoute, redirect } from "@tanstack/react-router";

// The Spanish URL of the "10 Years in Spain" company news article was renamed.
// Permanent redirect from the retired slug to the new one, thrown from
// beforeLoad so SSR answers with a real HTTP 301.
export const Route = createFileRoute("/es/noticias/qbd-group-10-anos-espana")({
  beforeLoad: () => {
    throw redirect({
      to: "/es/noticias/$slug",
      params: { slug: "qbd-group-spain-10-aniversario" },
      replace: true,
      statusCode: 301,
    });
  },
});
